<div class="dialog-container"
     style="border: 2px solid #20287b;
            border-radius: 10px;
            padding: 20px;
            background-color: #e3f2fd;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
            min-width: 350px;
            position: relative;">

  <!-- Cancel Button -->
  <!-- <button mat-icon-button color="primary"
          style="position: absolute; top: 8px; right: 8px;"
          matTooltip="close"
          (click)="onDiloagCancel()">
    <mat-icon style="font-size: 18px;">close</mat-icon>
  </button> -->

 <!-- <h6 style="text-align: center;"><b>Warning</b></h6>
   <button matTooltip="Cancel" class="box" style="margin-left: 96%;" (click)="onDiloagCancel()">
    <mat-icon style="padding-top: 28%;">cancel</mat-icon>
  </button> -->
<div style="width: 100%; display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 10px;">
    <h6 style="margin: 0; flex-grow: 1; text-align: center;"><b>WARNING</b></h6>
    <!-- <button mat-icon-button  color="primary" matTooltip="Cancel" class="box"  (click)="onDiloagCancel()">
    <mat-icon>cancel</mat-icon>
  </button> -->
  <button mat-icon-button color="primary" 
        matTooltip="Cancel" 
        class="box"  
        style="background: transparent !important;"
        (click)="onDiloagCancel()">
  <mat-icon>cancel</mat-icon>
</button>
  </div>

  <!-- Title -->
  
  <h1 mat-dialog-title style="margin-top: 19px; text-align: center;">{{ message }}</h1>

  <!-- Optional Description -->
  <mat-dialog-content style="text-align: center;">
    <p *ngIf="description">{{ description }}</p>
  </mat-dialog-content>

 <div *ngIf="data.buttonText" class="button-align" style="text-align: center; margin-top: 20px;">
  <button mat-flat-button 
          style="border: 1px solid #ccc; background-color: #f5f5f5; min-width: 60px; margin: 0 10px; box-shadow: 1px 1px 2px rgba(0,0,0,0.2);"
          (click)="onConfirmClick()">Yes</button>
  <button mat-flat-button 
          style="border: 1px solid #ccc; background-color: #f5f5f5; min-width: 60px; margin: 0 10px; box-shadow: 1px 1px 2px rgba(0,0,0,0.2);"
          (click)="onCancel()">No</button>
</div>

<!-- <div *ngIf="!data.buttonText" class="button-align" style="text-align: center; margin-top: 20px;">
  <button mat-flat-button 
          style="border: 1px solid #ccc; background-color: #f5f5f5; min-width: 60px; margin: 0 10px; box-shadow: 1px 1px 2px rgba(0,0,0,0.2);"
          (click)="onCancel()">No</button>
</div> -->
</div>
